import { useState } from "react";
import { RotateCcw } from "lucide-react";
import { SUN, INK, EMBER } from "./config";

export function ModulePriceEditor({ initial, onSave, onCancel, onRevert, testKey }) {
  const [val, setVal] = useState(String(initial));
  return (
    <span className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <span className="pcp-mono text-[10px] opacity-60">$</span>
      <input
        type="number"
        min="0"
        step="1"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") { e.preventDefault(); onSave(val); }
          if (e.key === "Escape") { e.preventDefault(); onCancel(); }
        }}
        autoFocus
        className="w-16 px-1.5 py-0.5 text-xs rounded"
        style={{ border: `1px solid ${SUN}`, background: "#fff" }}
        data-testid={`module-price-input-${testKey}`}
      />
      <button
        type="button"
        onClick={() => onSave(val)}
        className="pcp-mono text-[10px] px-1.5 py-0.5 rounded"
        style={{ background: SUN, color: INK }}
        data-testid={`module-price-save-${testKey}`}
      >
        Save
      </button>
      {onRevert && (
        <button
          type="button"
          onClick={onRevert}
          className="p-1 rounded hover:bg-black/10"
          title="Revert to default"
          data-testid={`module-price-revert-${testKey}`}
        >
          <RotateCcw className="h-3 w-3" style={{ color: EMBER }} />
        </button>
      )}
      <button
        type="button"
        onClick={onCancel}
        className="pcp-mono text-[10px] px-1.5 py-0.5 opacity-60"
        data-testid={`module-price-cancel-${testKey}`}
      >
        ✕
      </button>
    </span>
  );
}
